import { Injectable, Signal, WritableSignal, signal } from '@angular/core';
import { DEFAULT_HISTORY_RANGE, HISTORY_RANGE_OPTIONS, HistoryRangeOption } from './history-range.constants';

const STORAGE_KEY: string = 'splitzero.historyRange';

@Injectable({ providedIn: 'root' })
export class HistoryRangeService {
  private readonly rangeSignal: WritableSignal<number> = signal<number>(this.readInitial());

  readonly range: Signal<number> = this.rangeSignal.asReadonly();

  setRange(value: number): void {
    if (!this.isAllowed(value)) return;
    this.rangeSignal.set(value);
    this.write(value);
  }

  private isAllowed(value: number): boolean {
    return HISTORY_RANGE_OPTIONS.some((o: HistoryRangeOption): boolean => o.value === value);
  }

  private readInitial(): number {
    const raw: string | null = this.read(STORAGE_KEY);
    if (raw === null) return DEFAULT_HISTORY_RANGE;
    const n: number = Number(raw);
    return Number.isFinite(n) && this.isAllowed(n) ? n : DEFAULT_HISTORY_RANGE;
  }

  private read(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  }

  private write(value: number): void {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch {}
  }
}
